import '../styles/Loader.css';
import { createContext, useCallback, useContext, useState } from "react";

//Crea el contexto
const LoaderContext = createContext(null);

//Hook para usar el contexto
export const useLoader=()=>{
  const context =useContext(LoaderContext);
  if (!context) throw new Error('useLoader debe usarse dentro de LoaderProvider');
  return context;
}

//Provider
export const LoaderProvider=({children})=>{
  const [loading, setLoading] = useState(false);
  const showLoader=useCallback(()=>setLoading(true), []);
  const hideLoader=useCallback(()=>setLoading(false), []);

  return(
    <LoaderContext.Provider value={{loading, showLoader, hideLoader}}>
      {children}
      {loading && (
        <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(0,0,0,0.6)', display:'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1350 }}>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center'}}>
            <div className="gpem-container-loader">
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
            <div style={{color:'white'}}>Cargando...</div>
          </div>     
        </div>
      )}
    </LoaderContext.Provider>
  );
}